var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDepartmentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_26401",
    "data-name": "Group 26401",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.48,
    height: 18.322,
    viewBox: "0 0 18.48 18.322",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5349",
    "data-name": "Rectangle 5349",
    width: 18.48,
    height: 18.322,
    fill: "#c5c9f6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26400",
    "data-name": "Group 26400",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62153",
    "data-name": "Path 62153",
    d: "M97.19.04A.924.924,0,0,0,96,.925v17.4h3.234V15.088a.924.924,0,0,1,.924-.924h1.848a.924.924,0,0,1,.924.924v3.234h3.234V3.42a.924.924,0,0,0-.659-.885Zm2.045,5.346a.462.462,0,0,0-.462.462v.924a.462.462,0,0,0,.462.462h.924a.462.462,0,0,0,.462-.462V5.848a.462.462,0,0,0-.462-.462ZM98.772,8.62a.462.462,0,0,1,.462-.462h.924a.462.462,0,0,1,.462.462v.924a.462.462,0,0,1-.462.462h-.924a.462.462,0,0,1-.462-.462Zm.462,2.31a.462.462,0,0,0-.462.462v.924a.462.462,0,0,0,.462.462h.924a.462.462,0,0,0,.462-.462v-.924a.462.462,0,0,0-.462-.462Zm2.31-5.082a.462.462,0,0,1,.462-.462h.924a.462.462,0,0,1,.462.462v.924a.462.462,0,0,1-.462.462h-.924a.462.462,0,0,1-.462-.462Zm.462,2.31a.462.462,0,0,0-.462.462v.924a.462.462,0,0,0,.462.462h.924a.462.462,0,0,0,.462-.462V8.62a.462.462,0,0,0-.462-.462Zm-.462,3.234a.462.462,0,0,1,.462-.462h.924a.462.462,0,0,1,.462.462v.924a.462.462,0,0,1-.462.462h-.924a.462.462,0,0,1-.462-.462Z",
    transform: "translate(-91.842 0)",
    fill: "#c5c9f6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62154",
    "data-name": "Path 62154",
    d: "M3.234,76.052V60.344H1.848a.924.924,0,0,0-.924.924v13.86H.462a.462.462,0,1,0,0,.924Z",
    transform: "translate(0 -57.73)",
    fill: "#c5c9f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62155",
    "data-name": "Path 62155",
    d: "M354.772,153.225H352V141.011l1.844,1.054a.924.924,0,0,1,.466.8V152.3h.462a.462.462,0,1,1,0,.924",
    transform: "translate(-336.754 -134.903)",
    fill: "#c5c9f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5348",
    "data-name": "Rectangle 5348",
    width: 1.848,
    height: 3.234,
    transform: "translate(8.316 15.088)",
    fill: "#c5c9f6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartmentIcon);
export default __webpack_public_path__ + "static/media/department-icon.eb8b08ecad3c96f3304d429b6a4832b0.svg";
export { ForwardRef as ReactComponent };